// extracted by mini-css-extract-plugin
export default {"iconWrap":"CartIcon_iconWrap__5+s+7","glyph":"CartIcon_glyph__GFVlh","badge":"CartIcon_badge__iJ3tz"};